module.exports = __webpack_public_path__ + "img/banner-4.ee402fc9.jpg";